// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BxJ67","title":"styles_title__QksVq"};